<match-display-wrapper 
    matchLabel="{{ l10nKeys.jwtLabel | vtranslate }}"
    subheader="{{ tokenName }}"
>
    <div *ngFor="let claim of claims; trackBy: trackByIndex">
        {{ claim }}
    </div>
</match-display-wrapper>
